export default {
    setMiddlewareConnectionState: (state, connectionState) => {
        return state.setIn(['general', 'state'], connectionState);
    },
    setGroupId: (state, groupId) => {
        return state.set('groupId', groupId);
    },
    setAssigneeIds: (state, assigneeIds) => {
        return state.set('assigneeIds', assigneeIds);
    }
};



// WEBPACK FOOTER //
// ./environments/fhepool/core.js